module.exports = __webpack_public_path__ + "img/history.833b3447.svg";